import dynamic from "next/dynamic";
import Head from "next/head";

const Delivery2 = dynamic(() => import("@components/Components/CheckoutComponent/Delivery/Delivery"), {
  ssr: false,
})

const Delivery = ({deliveryData}) => {

  return (
    <>
      <Head>
        <title>{`${process.env.brand.brand_name} - Checkout - Delivery`}</title>
        <meta
            name="description"
            content={`${process.env.brand.brand_name} offer furniture hire, chair hire and table hire at exceptional prices throughout London and the UK. Order online now.`}
        />
      </Head>
      <Delivery2 {...deliveryData}/>
      {/* <DeliveryComponent /> */}
    </>
  )

}

export async function getServerSideProps() {
  const deliveryReq = await fetch(`${process.env.BASE_API_URL}checkout/delivery`);
  const deliveryData = await deliveryReq.json()

  // Pass data to the page via props
  return { 
    props: { deliveryData },
  }
}


export default Delivery